import { render, staticRenderFns } from "./recorder.vue?vue&type=template&id=4889f506&"
import script from "./recorder.vue?vue&type=script&lang=js&"
export * from "./recorder.vue?vue&type=script&lang=js&"
import style0 from "./recorder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports